import React from "react";
import { Form, Col, Row, Container } from "react-bootstrap";
import PostcodeInput from "../Common/PostcodeInput";

const AdvancedPostcodesFilters = ({ onFilterChange }) => {
  return (
    <Container className="mt-4">
      <Form>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="streetNumber">
              <Form.Label>Nr. domu</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("Number", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="type">
              <Form.Label>Typ rekordu</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("type", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="bazowy">bazowy</option>
                <option value="wirtualny">wirtualny</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="buildingType">
              <Form.Label>Typ budynku</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("buildingType", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="parity">
              <Form.Label>Parzystość numerów</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("parity", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="P">parzysty</option>
                <option value="N">nieparzysty</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="numberFrom">
              <Form.Label>Numer od</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("numberFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="numberTo">
              <Form.Label>Numer do</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("numberTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcodeFrom">
              <Form.Label>Kod od</Form.Label>
              <PostcodeInput
                onChange={(val) => onFilterChange("postcodeFrom", val)}
                inputMode="numeric"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="postcodeTo">
              <Form.Label>Kod do</Form.Label>
              <PostcodeInput
                onChange={(val) => onFilterChange("postcodeTo", val)}
                inputMode="numeric"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="exPn">
              <Form.Label>EX_PN</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exPn", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exWt">
              <Form.Label>EX_WT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exWt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exSr">
              <Form.Label>EX_SR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exSr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exCz">
              <Form.Label>EX_CZ</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exCz", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exPt">
              <Form.Label>EX_PT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exPt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exSo">
              <Form.Label>EX_SO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exSo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="drPn">
              <Form.Label>DR_PN</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drPn", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drWt">
              <Form.Label>DR_WT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drWt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drSr">
              <Form.Label>DR_SR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drSr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drCz">
              <Form.Label>DR_CZ</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drCz", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drPt">
              <Form.Label>DR_PT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drPt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drSo">
              <Form.Label>DR_SO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drSo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="wPn">
              <Form.Label>W_PN</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("wPn", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="wWt">
              <Form.Label>W_WT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("wWt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="wSr">
              <Form.Label>W_SR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("wSr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="wCz">
              <Form.Label>W_CZ</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("wCz", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="wPt">
              <Form.Label>W_PT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("wPt", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="soN">
              <Form.Label>SO_N</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("soN", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="soO">
              <Form.Label>SO_O</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("soO", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="lastBPn">
              <Form.Label>LastB_PN</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBPn", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="lastBWt">
              <Form.Label>LastB_WT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBWt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="lastBSr">
              <Form.Label>LastB_SR</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBSr", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="lastBCz">
              <Form.Label>LastB_CZ</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBCz", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="lastBPt">
              <Form.Label>LastB_PT</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBPt", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="lastBSo">
              <Form.Label>LastB_SO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("lastBSo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="resPnOd">
              <Form.Label>RES_PN_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resPnOd", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resWtOd">
              <Form.Label>RES_WT_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resWtOd", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resSrOd">
              <Form.Label>RES_SR_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resSrOd", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resCzOd">
              <Form.Label>RES_CZ_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resCzOd", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resPtOd">
              <Form.Label>RES_PT_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resPtOd", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resSoOd">
              <Form.Label>RES_SO_OD</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resSoOd", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="resPnDo">
              <Form.Label>RES_PN_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resPnDo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resWtDo">
              <Form.Label>RES_WT_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resWtDo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resSrDo">
              <Form.Label>RES_SR_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resSrDo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resCzDo">
              <Form.Label>RES_CZ_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resCzDo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resPtDo">
              <Form.Label>RES_PT_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resPtDo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="resSoDo">
              <Form.Label>RES_SO_DO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("resSoDo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="service9">
              <Form.Label>Service_9</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("service9", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="service12">
              <Form.Label>Service_12</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("service12", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="service1722">
              <Form.Label>Service_17_22</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("service1722", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="zone">
              <Form.Label>Strefa</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("zone", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="region">
              <Form.Label>Obszar</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("region", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="M">M</option>
                <option value="T">T</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="building">
              <Form.Label>Budynek</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("building", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="buildingDhl">
              <Form.Label>Budynek DHL</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("buildingDhl", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="exHist">
              <Form.Label>EX_HIST</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("exHist", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group controlId="exHistFrom">
              <Form.Label>EX_HIST_FROM</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exHistFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="exHistTo">
              <Form.Label>EX_HIST_TO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("exHistTo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="drHist">
              <Form.Label>DR_HIST</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("drHist", e.target.value)}
              >
                <option value={null}>-- Wybierz --</option>
                <option value={true}>TAK</option>
                <option value={false}>NIE</option>
              </Form.Control>
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group controlId="drHistFrom">
              <Form.Label>DR_HIST_FROM</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drHistFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="drHistTo">
              <Form.Label>DR_HIST_TO</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                onChange={(e) => onFilterChange("drHistTo", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="exComMet">
              <Form.Label>EX_COM_MET</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => onFilterChange("exComMet", e.target.value)}
              >
                <option value="">-- Wybierz --</option>
                <option value="H">H</option>
                <option value="H+A">H+A</option>
                <option value="E">E</option>
                <option value="M">M</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default AdvancedPostcodesFilters;
